import { Transition } from "@headlessui/react";
import { ArrowRightIcon } from "@heroicons/react/24/outline";
import { XIcon } from "lucide-react";
import { Fragment, useEffect, useState } from "react";
import useShop from "@babackapp/private-api-client/client/use-shop";
import { useParams } from "react-router-dom";
import { useGetCustomerCarrierPortalLink } from "@babackapp/private-api-client/client/use-get-customer-carrier-portal-link";

export default function BillingWarningCarrierSetupPopup() {
  const params = useParams<{ shopId: string }>();
  const shopId = params.shopId || "";
  const { data: shop } = useShop(shopId);
  const { data: carrierPortalLink } = useGetCustomerCarrierPortalLink(shopId);
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    console.log("carrierPortalLink", carrierPortalLink);
  }, [carrierPortalLink]);

  useEffect(() => {
    if (shop?.billing.stripe.warningCarrierStripeAccount) {
      setTimeout(() => {
        setIsOpen(true);
      }, 1000);
    }
  }, [shop]);

  const onClose = () => {
    setIsOpen(false);
  };

  const handleSepaClick = () => {
    if (carrierPortalLink) {
      window.open(carrierPortalLink, "_blank");
    }
  };

  if (!shop?.billing.stripe.warningCarrierStripeAccount) return null;

  return (
    <Transition
      show={isOpen}
      as={Fragment}
      enter="transition ease-in-out duration-250"
      enterFrom="opacity-0"
      enterTo="opacity-100"
      leave="transition ease-in-out duration-250"
      leaveFrom="opacity-100"
      leaveTo="opacity-0"
    >
      <div className="bg-red-600 text-white fixed top-16 left-0 right-0 h-16 z-50 flex flex-row justify-center items-center space-x-4 px-4">
        <div className="flex-1 flex flex-row justify-center items-center space-x-4">
          <div className="text-center">
            <span className="font-semibold">
              Action nécessaire pour le{" "}
              <span className="underline">transport Baback</span> :
            </span>{" "}
            Ajoutez votre SEPA ici pour garantir les services BABACK LOG avant
            le 28/11/25
          </div>
          <button
            type="button"
            className="inline-flex cursor-pointer justify-center items-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-white text-base font-medium text-red-600 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 sm:text-sm space-x-2 transition-colors"
            onClick={handleSepaClick}
          >
            <div>Ajouter mon SEPA</div>
            <ArrowRightIcon className="w-4 h-4" />
          </button>
        </div>
        <button
          onClick={onClose}
          className="hover:bg-white/20 rounded p-1 transition-colors"
        >
          <XIcon className="w-4 h-4" />
        </button>
      </div>
    </Transition>
  );
}
